/* Keep reference searches readable while explicitly searching variant SKUs. */
(() => {
  if(window.AutoDiazSearchQuery)return;
  const compact=value=>String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]/g,'');
  const literal=value=>'"'+String(value).replace(/["\\]/g,' ').trim()+'"';
  function isReference(value) {
    const text=String(value || '').trim();
    if(text.length>100 || !/^[a-z0-9\s./+_-]+$/i.test(text) || !/\d/.test(text) || compact(text).length<5)return false;
    const words=text.split(/\s+/);
    return words.length===1 || words.every(word=>/[0-9]/.test(word) || /^[a-z]{1,3}$/i.test(word));
  }
  function query(value) {
    const text=String(value || '').trim();if(!isReference(text))return text;
    const code=compact(text).toUpperCase();
    return '('+[literal(text),'variants.sku:'+literal(text),'variants.sku:'+literal(code),'tag:'+literal('OEM:'+code)].filter((v,i,a)=>a.indexOf(v)===i).join(' OR ')+')';
  }
  function term(params) {
    const q=params.get('q') || '',display=params.get('ad_term') || '';
    if(display && isReference(display) && query(display)===q)return display;
    return q.match(/^variants\.sku:\s*"?([^"\s]+)"?$/i)?.[1] || q;
  }
  window.AutoDiazSearchQuery={compact,isReference,query,term};
  document.addEventListener('submit',event=>{
    const form=event.target;if(event.defaultPrevented || !(form instanceof HTMLFormElement) || form.method.toLowerCase()!=='get' || form.querySelector('[name="ad_vehicle"][value="1"]'))return;
    const target=new URL(form.action,location.href),input=form.querySelector('input[type="search"][name="q"],input[type="search"][name="ad_term"]');
    if(!input || target.origin!==location.origin || !/\/search\/?$/.test(target.pathname))return;
    const text=input.value.trim(),encoded=query(text),hidden=form.querySelector('[data-ad-reference-query]');
    if(encoded===text){input.name='q';hidden?.remove();return;}
    input.name='ad_term';const field=hidden || document.createElement('input');field.type='hidden';field.name='q';field.value=encoded;field.dataset.adReferenceQuery='';if(!hidden)form.append(field);
  });
  const params=new URLSearchParams(location.search),q=params.get('q') || '',display=term(params);
  if(params.get('ad_vehicle')==='1') {
    document.querySelectorAll('header input[type="search"][name="q"]').forEach(input=>{if(input.value===q)input.value=params.get('ad_part') || '';});
  } else if(display!==q) {
    document.querySelectorAll('input[type="search"][name="q"]').forEach(input=>{if(input.value===q)input.value=display;});
    const heading=document.querySelector('.ad-search-hero h1');if(heading)heading.textContent='Resultados para “'+display+'”';
    const preserve=()=>{
      document.querySelectorAll('[data-ad-native] a[href]').forEach(link=>{
        const target=new URL(link.href,location.href);if(target.origin!==location.origin || target.pathname!==location.pathname || target.searchParams.get('q')!==q)return;
        for(const key of ['ad_term','ad_basic','preview_theme_id'])if(params.has(key))target.searchParams.set(key,params.get(key));
        link.href=target.toString();
      });
    };
    preserve();document.querySelectorAll('[data-ad-native]').forEach(host=>new MutationObserver(preserve).observe(host,{childList:true,subtree:true}));
  }
})();
